function roundPoint(pt, sddp) {
  return {
    x: Math.round((pt.x + Number.EPSILON) * 10 ** sddp) / 10 ** sddp,
    y: Math.round((pt.y + Number.EPSILON) * 10 ** sddp) / 10 ** sddp,
  };
}

export default roundPoint;
